import script from "./AIChats.vue?vue&type=script&setup=true&lang=js"
export * from "./AIChats.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./AIChats.vue?vue&type=style&index=1&id=15fdc6b0&lang=css"

const __exports__ = script;

export default __exports__